export default "__VITE_ASSET__IK4$Uw05__"